import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

interface CirclePlaceHolderProps {
  className?: string;
  size?: number;
}

const CirclePlaceHolder: FunctionComponent<CirclePlaceHolderProps> = ({
  className,
}) => {
  return <div className={className || ''} />;
};

export default styled(CirclePlaceHolder)`
  width: ${(props) => (props.size ? `${props.size}px` : '24px')};
  height: ${(props) => (props.size ? `${props.size}px` : '24px')};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.box};
`;
